import { stats } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import {
    logAPIError,
    MutationManager,
    variation as sharedApiVariation,
    checkVariationReady,
    initPackagePurchaseSession,
    CHECKOUT_FLOW,
    PACKAGES_FLOW,
} from '@fiverr-private/variations_display';
import metrics from '../../../../../service/metrics';
import { getMixpanelEnrichment, validateVariationId } from '../../../../../shared/lib';
import { APP_NAME } from '../../constants';

const purchaseBuyerVariation = ({ selectedVariationId, projectId, brandName, briefId, isPostponedAction = false }) => {
    const mutations = MutationManager.getMutations(selectedVariationId);

    return sharedApiVariation.purchase({
        projectId,
        brandName,
        sourceVariationId: selectedVariationId,
        roots: mutations.roots,
        log: {
            isPostponedAction,
        },
        context: {
            briefId,
        },
    });
};

const logInvalidVariationId = (context) => logAPIError(new Error('Failed to get a valid variation id'), context);

export const buyVariation = async ({
    isProjectOwner,
    projectId,
    selectedVariationId,
    brandName,
    slogan,
    briefId,
    refCtxId,
    availablePackages,
    isFreeVariation,
    isDraftVariation,
}) => {
    if (isProjectOwner) {
        window.location = pathfinder(
            'logo_maker_packages_page_logo_maker_projects_project_id_packages_preview',
            { project_id: projectId },
            { query: { source: APP_NAME } }
        );
        return true;
    }

    const variationId = isDraftVariation
        ? selectedVariationId
        : await purchaseBuyerVariation({
              selectedVariationId,
              brandName,
              projectId,
              briefId,
          });

    const flowName = availablePackages?.length === 1 ? CHECKOUT_FLOW : PACKAGES_FLOW;
    if (validateVariationId(variationId)) {
        if (!isFreeVariation) {
            await checkVariationReady(APP_NAME, stats)(variationId, flowName);
        }

        if (availablePackages?.length === 1) {
            return initPackagePurchaseSession({
                projectId,
                variationId,
                brandName,
                slogan,
                packageType: availablePackages[0].packageType,
                source: 'choose_variation',
                refCtxId,
                mixpanelEnrichment: getMixpanelEnrichment(),
                metricsReporter: metrics,
            });
        }

        window.location = pathfinder(
            'logo_maker_packages_page_logo_maker_projects_project_id_variations_variation_id_packages_preview',
            { project_id: projectId, variation_id: variationId },
            {
                query: {
                    ref_ctx_id: refCtxId,
                    source: 'choose_variation',
                    ...(briefId && { brief_id: briefId }),
                },
            }
        );

        return true;
    }

    logInvalidVariationId({ variationId, projectId, flow: flowName });

    return false;
};
